import { IParameter, IParameterGroup, TCreateGroupParameterDTO, TCreateParameterDTO } from './parameters.types'
import axios from 'axios'
import { HTTPResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '../../services/http'

const createGroup = (
  dto: TCreateGroupParameterDTO
): Promise<HTTPResponse<IParameterGroup>> => {
  return http
    .post('/nsi/v1/parameters/groups', { name: dto.name, parentId: dto.parentId > 0 ? dto.parentId : null })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const updateGroup = (dto: Omit<IParameterGroup, 'createdAt' | 'updatedAt'>): Promise<HTTPResponse<IParameterGroup>> => {
  return http
    .patch(`/nsi/v1/parameters/groups/${dto.id}`, { name: dto.name, parentId: dto.parentId > 0 ? dto.parentId : null })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteGroup = (id: IParameterGroup['id']): Promise<HTTPResponse<IParameterGroup>> => {
  return http.delete(`/nsi/v1/parameters/groups/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const createParameter = (
  dto: TCreateParameterDTO
): Promise<HTTPResponse<IParameter>> => {
  return http.post('/nsi/v1/parameters', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateParameter = (dto: Omit<IParameter, 'createdAt' | 'updatedAt'>): Promise<HTTPResponse<IParameter>> => {
  return http
    .patch(`/nsi/v1/parameters/${dto.id}`, {
      dataType: dto.dataType,
      groupId: dto.groupId,
      name: dto.name,
      unitId: dto.unitId,
      unitPrefixId: dto.unitPrefixId,
    })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteParameter = (id: IParameter['id']): Promise<HTTPResponse<IParameter>> => {
  return http.delete(`/nsi/v1/parameters/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const exportParameter = (access: string): Promise<HTTPResponse> => {
  return axios
    .get(`/nsi/v1/parameters/export/groups/parameters.gz?accessToken=${access}`)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const importParameter = (formData: FormData): Promise<HTTPResponse> => {
  return http.post(`/nsi/v1/parameters/import/parameters`, formData).then(handleHttpResponse).catch(handleHttpError)
}

const parametersApi = {
  createGroup,
  updateGroup,
  deleteGroup,
  createParameter,
  updateParameter,
  deleteParameter,
  exportParameter,
  importParameter,
}
export default parametersApi
